/**
 * Permission codes of the Control Levels screen (FSD 2.2.5 FIN-F06 V06).
 *
 * The dot-strings `internal/budget/permissions.go` registers for
 * `GET /budget-control-levels` (`read`) and `PUT /budget-control-levels` (`manage`).
 * A control level per cost centre with a tolerance, plus the company default's no-line
 * rule, is the one way a budget is enforced.
 *
 * `manage` lets a person ASK for a change. Whether it takes effect at once is the
 * server's decision: a tightening applies immediately, a loosening waits for a second
 * person through the approvals engine — the screen shows which one happened, it does
 * not decide it.
 */
export const BUDGET_CONTROL_LEVEL_PERMISSIONS = {
  read: 'budget.control_level.read',
  manage: 'budget.control_level.manage',
} as const
